import type { DashboardState } from '../index';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setOverview = (state: DashboardState, { payload }: { payload: any /*TODO*/ }) => {
  state.overview = payload;
};
